import { Grid } from "@mui/material"

interface IOrganizationInfoWrapper {
    children: React.ReactNode;
    userError: boolean;
}

export const OrganizationInfoWrapper: React.FunctionComponent<IOrganizationInfoWrapper> = ({
    children,
    userError
}) => {
    return (
        <Grid container width="100%" sx={{ opacity: `${userError ? .3 : 1 }` }}>
            <Grid container height="100%" sx={{
                width: "100%",
                height: "calc( 100vh - 338px)",
                }} padding="0 30px">
                    { children }
                </Grid>
        </Grid>
    )
}